/* eslint-disable react-hooks/exhaustive-deps */
import { createContext, useContext, useEffect, useReducer } from "react";
import { useAuth } from "./auth";
import axios from "axios";

const initialState = {
  wishlist: [],
};

const wishlistReducer = (state, action) => {
  switch (action.type) {
    case "SET_WISHLIST":
      return { wishlist: action.payload };
    case "ADD_TO_WISHLIST":
      return { wishlist: [...state.wishlist, action.payload] };
    case "REMOVE_FROM_WISHLIST":
      return {
        wishlist: state.wishlist.filter((item) => item.id !== action.payload),
      };
    default:
      return state;
  }
};

const WishlistContext = createContext();

export const WishlistProvider = ({ children }) => {
  const [state, dispatch] = useReducer(wishlistReducer, initialState);
  const [auth] = useAuth();

  useEffect(() => {
    if (auth?.user?.id) {
      axios
        .get(`${process.env.REACT_APP_API_URL}/customer/wish-list`, {
          params: { customer_id: auth.user.id },
        })
        .then((response) => {
          dispatch({ type: "SET_WISHLIST", payload: response.data });
        })
        .catch((error) => {
          console.error("Error fetching wishlist:", error);
        });
    }
  }, [auth]);

  const addToWishlist = async (userId, productId) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/customer/wish-list/add`,
        { customer_id: userId, product_id: productId }
      );

      if (response.status === 200) {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_URL}/customer/wish-list`,
          { params: { customer_id: userId } }
        );

        dispatch({ type: "SET_WISHLIST", payload: data });

        return response.data;
      }
    } catch (error) {
      console.error("Error adding item to wishlist:", error);
      return { status: false, message: "Something went wrong!" };
    }
  };

  const removeFromWishlist = async (userId, productId, confirm = 1) => {
    try {
      if (confirm === 1) {
        const confirmDelete = window.confirm(
          "Are you sure you want to remove this item?"
        );
        if (!confirmDelete) return;
      }

      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/customer/wish-list/remove`,
        { params: { customer_id: userId, product_id: productId } }
      );

      const { data } = await axios.get(
        `${process.env.REACT_APP_API_URL}/customer/wish-list`,
        {
          params: { customer_id: userId },
        }
      );

      dispatch({ type: "SET_WISHLIST", payload: data });
      return response.data;
      
    } catch (error) {
      console.error("Error removing item from wishlist:", error);
    }
  };

  return (
    <WishlistContext.Provider
      value={{ ...state, addToWishlist, removeFromWishlist }}
    >
      {children}
    </WishlistContext.Provider>
  );
};

export const useWishlist = () => useContext(WishlistContext);
